export { default as ShiftTransferPolicies } from './shiftTransferPolicies.container';
